import { EAppProperties } from '@timeedit/types/lib/enums';

export const TITLE_APP_PROPERTY = 'App Property';
export const TITLE_OBJECT_TYPE_GROUP = 'Object Type Group';
export const TITLE_REQUIRED_CONFIGURATION = 'Required Field Configuration';
export const FIELD_CONFIGURATION = 'Field Configuration';

export const mappingApp = {
  tePreferences: 'TE_PREFERENCES',
  teExam: 'TE_EXAM',
  teExamV3: 'TE_EXAM_V3',
  teReporting: 'TE_REPORTING',
} as const;

export const AppPropertiesNotUsed: string[] = [];

export const AppPropertiesNames = {
  [EAppProperties.DEDICATETRACK]: 'Allocation constraints',
  [EAppProperties.HIDETRACK]: 'Hide for allocate/registration',
};
